import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import DescriptionList from '@anwb/poncho/components/description-list';
import Panel from '@anwb/poncho/components/panel';
import { PanelEditHeader } from 'components/RequestFlow/components/PanelEditHeader/PanelEditHeader';
import { useGaFunnelInfo } from 'hooks/useGaFunnelInfo';
import {
	chosenDurationSelector,
	chosenKilometrageSelector,
	isFlexSelector,
	leaseCarGroupedPricePointsSelector,
} from 'store/selectors';
import { KeyValuePair } from 'types';
import { formatKilometrageDescription } from 'utils';
import { STEPS, getStepPathWithCarParam } from 'utils/navigation';

import { customOverviewChangeGA4TrackEvent } from '../util/datalayerEvent';

export const KilometrageAndContractTerm = () => {
	const groupedPricePoints = useSelector(leaseCarGroupedPricePointsSelector);
	const selectedKilometrage = useSelector(chosenKilometrageSelector);
	const selectedContractTerm = useSelector(chosenDurationSelector);
	const isFlex = useSelector(isFlexSelector);
	const gaFunnelInfo = useGaFunnelInfo();

	const [kilometrageAndContractTermItems, setKilometrageAndContractTermItems] = useState<
		KeyValuePair[]
	>([]);

	useEffect(() => {
		if (groupedPricePoints && selectedContractTerm && selectedKilometrage) {
			const kilometrageObject = groupedPricePoints[Number(selectedContractTerm)].kilometrages.find(
				(k) => k.mileage === Number(selectedKilometrage)
			);

			if (kilometrageObject) {
				setKilometrageAndContractTermItems([
					{
						key: 'Looptijd',
						value: isFlex
							? 'Na 6 maanden, gratis per maand opzegbaar'
							: `${selectedContractTerm} maanden`,
					},
					{
						key: 'Aantal kilometers per jaar',
						value: `${formatKilometrageDescription(kilometrageObject.description)} km`,
					},
				]);
			}
		}
	}, [groupedPricePoints, isFlex, selectedContractTerm, selectedKilometrage]);

	const title = 'Looptijd en kilometers';

	const handleClick = () => {
		customOverviewChangeGA4TrackEvent(title, gaFunnelInfo);
	};

	return (
		<Panel
			id="kilometrage-contract-term-overview"
			hasOuterSpacing={false}
			dataTest="kilometrage-contract-term-overview"
		>
			<Panel.Content>
				<PanelEditHeader
					title={title}
					onClick={handleClick}
					getStepPath={getStepPathWithCarParam}
					stepToEdit={STEPS.CAR_CONTRACT}
					dataTest="kilometrage-contract-term-overview-change-link"
				/>

				<DescriptionList
					items={kilometrageAndContractTermItems}
					dataTest="kilometrageAndContractTerm"
				/>
			</Panel.Content>
		</Panel>
	);
};
